import React from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import Form from "../../../components/forms/LoginForms";
import { loginAction } from "../../../../../utils/login";

const onSubmit = loginAction(
  "/verejnost/api/auth/basic",
  "/verejnost-prihlasen/hlavni",
);

const goBackAction = () => push("/");

const ConnectedForm = connect(null, { onSubmit, goBack: goBackAction })(Form);

const PublicLogin = () => (
  <ConnectedForm niaButton role="public" title="Přihlášení pro veřejnost" />
);

export default PublicLogin;
